import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../hooks/useMain';
import Anchor from './common/anchor';
import Image from './common/image';
import Socials from './common/socials';

const Footer = ({ isGlobal }) => {
	const { theme } = useMain();
	const socials = [
		{
			name: 'main twitter account',
			className: 'fab fa-twitter',
			link: 'https://twitter.com/bcntoken',
		},
		{
			name: 'discord',
			className: 'fab fa-discord',
			link: 'https://discord.io/bemfoundation',
		},
		{
			name: 'instagram',
			className: 'fab fa-instagram',
			link: 'https://www.instagram.com/bcntoken/',
		},
		{
			name: 'telegram channel',
			className: 'fab fa-telegram-plane',
			link: 'https://t.me/bcntoken',
		},
		{
			name: 'youtube channel',
			className: 'fab fa-youtube',
			link: 'https://www.youtube.com/@bemfoundation',
		},
	];

	if (!isGlobal) return null;

	return (
		<footer className='text-main'>
			<div className='my-footer'>
				<div className='container py-5'>
					<div className='row gy-5 mx-sm-5'>
						<div className='col-md-3'>
							<Link to='/'>
								<Image
									fileName={`logo/${theme}.webp`}
									height='80px'
								/>
							</Link>

							<p className='mt-3 mb-5'>
								The safest and most reliable way to invest in the cryptocurrency
								market
							</p>
							<Socials
								data={socials}
								navClass='justify-content-start pb-5'
								iconsClass='socialIcons me-2'
							/>
						</div>

						<div className='col-md-3 text-center'>
							<div className='d-inline-block'>
								<b className='px-5'>Usefull Links</b>
								<hr className='my-2' />
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://bems.market'
									content='BEMS.MARKET'
								/>
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://tronscan.org/#/token20/TAoA331n3iKDkR62kAZ4H2n3vNL7y3d8x9/code'
									content='BCN Contract'
								/>
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://sunswap.com/#/home?tokenAddress=TAoA331n3iKDkR62kAZ4H2n3vNL7y3d8x9&type=swap'
									content='Buy BCN'
								/>
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://bcntoken.com'
									content='bcntoken.com'
								/>
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://tronscan.org/#/token20/TQH4JFjzGnWswNeaCxFJi3pSqmsvTXULY8/code'
									content='TIM Contract'
								/>
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://sunswap.com/#/home?tokenAddress=TQH4JFjzGnWswNeaCxFJi3pSqmsvTXULY8&type=swap'
									content='Buy TIM'
								/>
							</div>
							<div>
								<Anchor
									className={`text-main`}
									href='https://timtoken.io'
									content='timtoken.io'
								/>
							</div>
							<div>
								<Link
									className={`text-main`}
									to='/mmiQuery'>
									MMI Query
								</Link>
							</div>
						</div>

						<div className='col-md-3 text-center'>
							<div className='d-inline-block'>
								<b className='px-5'>Services</b>
								<hr className='my-2' />
							</div>
							<div>Investment</div>
							<div>Insurance</div>
							<div>Lending</div>
							<div>Stock Market</div>
							<div>Store</div>
							<div>NFT Collection </div>
							<div>Forex Market</div>
						</div>

						<div className='col-md-3 text-center'>
							<h4 className='fw-bold mb-3'>Contact Information</h4>
							<p>
								<i className='me-2 fas fa-home'></i>MMP Organization
							</p>
							<p>
								<i className='me-2 fas fa-envelope'></i>
								contact@mmp.world
							</p>
							<hr className='my-2' />

							<div>
								<Anchor
									className='text-main'
									href='https://bemfoundation.com'
									content={
										<div className='mt-2'>
											Powered By: <br />
											<Image
												height='25px'
												fileName={`logo/bem_${theme}.png`}
											/>{' '}
											BEM Foundation
										</div>
									}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='my-footer-bottom py-3'>
				<div className='container'>
					<div className='row'>
						<div className='col-12 text-center'>
							<span>
								© {new Date().getFullYear()} BEM FOUNDATION, Inc. All rights
								reserved.
							</span>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
